var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container-box flex-b-r"},[_c('div',{staticClass:"login-Main-body"},[_c('p',{staticClass:"firm-clickable",on:{"click":_vm.handelPaymentCompleted}},[_vm._v("支付完成")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }